module.exports = __webpack_public_path__ + "static/media/Noorlina_Alal.230e99fe.png";